import { useTranslation } from 'react-i18next';
import useAppTheme from 'hooks/useAppTheme';
import { FlexBox, StyledTypography, SubText } from './SensorAnalysis.styles';
import { Selector } from 'components/Form/Selectors/Selector';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { type SelectChangeEvent } from '@mui/material';
import {
  type AggregationType,
  setAggregation,
} from 'store/sensorAnalysis.slice';
import { AVG_VAL } from 'utils/enums';

const AGGREGATION_LABEL_KEYS: Record<string, string> = {
  avg_val: 'avg_value',
  max_val: 'max_value_option',
  min_val: 'min_value_option',
};

export const AggregationOptions = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { enableDarkTheme } = useAppTheme();
  const dataType = useAppSelector(
    (state) => state.sensorAnalysisReducer.dataType
  );
  const aggregation = useAppSelector(
    (state) => state.sensorAnalysisReducer.aggregation
  );

  const handleAggregationChange = (event: SelectChangeEvent<number>) => {
    dispatch(setAggregation(event.target.value as AggregationType));
  };

  const aggregationOptions = AVG_VAL.map((opt) => ({
    ...opt,
    display: t(AGGREGATION_LABEL_KEYS[opt.id] ?? opt.id, {
      defaultValue: opt.display,
    }),
  }));

  return (
    <>
      <FlexBox sx={{ gap: 0.5 }}>
        <StyledTypography>
          <SubText>{t('aggregation_word')}</SubText>
        </StyledTypography>
        <Selector
          minWidth="1px"
          value={aggregation}
          onChange={(event) => {
            handleAggregationChange(event);
          }}
          selectorOptions={aggregationOptions}
          enableDarkTheme={enableDarkTheme}
          disabled={dataType !== 'regular'}
        />
      </FlexBox>
    </>
  );
};

AggregationOptions.displayName = 'AggregationOptions';

export default AggregationOptions;
